<template>
  <v-touch @press="pressed"
    @pressup="pressedup"
    @panleft="msgPanAction($event)"
    v-bind:class="{
      selected: selected
    }"
    class="fRow jStart aCenter">
    <div class="selectBox"
      v-bind:class="{
        show: selectMode,
        selectedMsg: selected}"></div>
    <div class="fRow fullWidth msgHolder"
      v-bind:class="{
        rightMenued: rightMenu,
        otherHolder: sender !== 'you'}"
      @contextmenu="customRightMenu($event)">
      <div class="selectBigButton" v-ripple v-if="selectMode" @click="selectThis"></div>
      <div class="selectBigButton rc" v-if="closeRightMenuButton"
        @click="closeRightMenu"></div>
      <ul class="rightMenu secondary fCol jStart aCenter"
        v-if="rightMenu"
        v-bind:style="{
          top: `${rightMenuPosition.y}px`,
          left: `${rightMenuPosition.x}px`
        }">
        <li class="fRow jStart aCenter fullWidth transition-fast"
          v-if="!selectMode || selecteds.length === 1" @click="replyThis">
          <i class="material-icons-round">reply</i>
          <label class="growFull">پاسخ دادن</label>
        </li>
        <li class="fRow jStart aCenter fullWidth transition-fast">
          <i class="material-icons-round">forward</i>
          <label class="growFull">ارسال به دیگران</label>
        </li>
        <li class="fRow jStart aCenter fullWidth transition-fast"
          @click="selectThis">
          <i class="material-icons-round">check_box</i>
          <label class="growFull">انتخاب پیام</label>
        </li>
        <li class="fRow jStart aCenter fullWidth transition-fast"
          v-if="message.length > 0">
          <i class="material-icons-round">content_copy</i>
          <label class="growFull">کپی متن</label>
        </li>
        <li class="fRow jStart aCenter fullWidth transition-fast">
          <i class="material-icons-round">delete_outline</i>
          <label class="growFull">حذف پیام / پیام‌ها</label>
        </li>
      </ul>
      <div class="msgBox fRow jStart aCenter"
        v-bind:style="{transform: `translateX(-${this.replyMargin / 2}px)`}"
        v-bind:class="{
          selecteds: selectMode,
          other: sender !== 'you'}" :id="`m${index}`">
        <!-- <div class="avatar"></div> -->
        <div class="bilbilak" v-if="!showBilbilak"
          v-bind:class="{selectedB: selectMode}"></div>
        <div class="msg fRow jBetween aStart wrap" v-bind:class="{round: showBilbilak}">
          <!-- اگه ریپلای داشت این بلاک نشون داده بشه -->
          <div class="replyBox fullWidth" v-if="hasReply">
            <div class="holder fRow jStart aCenter">
              <div class="mediaPreview"
                v-if="replyHasMedia">
                <img :src="replyTo.thumb">
              </div>
              <div class="replyContent fCol jCenter aStart growFull">
                <div class="to" v-if="replyTo.sender !== 'you'">علیرضا عباسپور:</div>
                <div class="to" v-if="replyTo.sender === 'you'">شما:</div>
                <div class="msgPreview">{{replyTo.message}}</div>
              </div>
            </div>
          </div>
          <!-- اگه ویس بود این بلاک نشون داده میشه -->
          <div class="voiceHolder fRow fullWidth jBetween aStart wrap" v-if="type === 'voice'">
            <audio ref="voice" :src="media" preload="none"></audio>
            <div class="voiceVisualHolder fCol jEnd aStart">
              <av-waveform
                ref-link="voice"
                :canv-width="178"
                :canv-height="44"
                played-line-color="#ffffff"
                noplayed-line-color="#ffffff33"
                playtime-font-color="#ffffff"
                playtime-slider-color="#ff000000"
                playtime-font-family="Vazir FD"
                :playtime="false"
                :playtime-text-bottom="true"
                :playtime-slider-width="0"
                :playtime-slider="false"
                :playtime-with-ms="false"
                :audio-controls="false"
              ></av-waveform>
              <div class="voiceTime">{{time}}</div>
            </div>
            <i class="playButton material-icons-round" v-if="!isPlaying" @click="playVoice">
                play_arrow
                <div class="played" v-if="!audioPlayed"></div>
              </i>
            <i class="playButton material-icons-round"
              v-if="isPlaying" @click="puaseVoice">pause</i>
          </div>
          <!-- اگه عکس بود این بلاک نشون داده میشه -->
          <div class="photoHolder fullWidth" v-if="type === 'photo' || type === 'video'">
            <img :src="thumb" alt="" @load="imgLoaded" @click="openPhoto">
            <i class="material-icons-round playBtn" v-if="type === 'video'">play_circle</i>
          </div>
          <div class="text fullWidth" v-if="message.length > 0" v-html="finalMsg()"></div>
          <div class="statusHolder fRow jStart aCenter">
            <i class="material-icons-round sent"
              v-if="sender === 'you'">done</i>
            <div class="date">2 ساعت قبل</div>
          </div>
        </div>
      </div>
    </div>
  </v-touch>
</template>

<script>
import { EventBus } from '@/plugins/event-bus';

export default {
  props: ['index', 'showBilbilak', 'sender', 'message', 'senderName',
    'replyTo', 'type', 'media', 'thumb', 'id'],
  data() {
    return {
      isPlaying: false,
      audioPlayed: false,
      selectMode: false,
      selected: false,
      replyMargin: 0,
      hasReply: false,
      replyHasMedia: false,
      time: 0,
      duration: '',
      generatedMessage: '',
      rightMenu: false,
      closeRightMenuButton: false,
      rightMenuPosition: {
        x: 0,
        y: 0,
        overx: false,
        overy: false,
      },
    };
  },
  methods: {
    selectThis() {
      // this.activeSelectMode();
      // if (this.selected) {
      //   // this.selectMode = true;
      // }
      // اینجا باید برای همه مسیج ها سلکت مود آن بشه
      EventBus.$emit('selectModeOn', {
        index: this.index,
        id: this.id,
      });
      this.closeRightMenu();
    },
    replyThis() {
      this.$store.commit('replyThis', {
        id: this.id,
        type: this.type,
        sender: this.sender,
        thumb: this.thumb,
        message: this.message,
      });
      this.closeRightMenu();
    },
    pressed() {
      this.replyMargin = 0;
      this.selectThis();
    },
    pressedup() {
      this.replyMargin = 0;
    },
    msgPanAction(e) {
      if (!this.selectMode) {
        this.replyMargin = Math.abs(e.deltaX);
        // if (Math.abs(e.deltaX) < 60) {
        // }
        if (e.isFinal) {
          if (this.replyMargin > 100) {
            // this.replyThis();
          }
          this.replyMargin = 0;
        }
      }
    },
    finalMsg() {
      return this.generatedMessage;
    },
    // voice n video
    playVoice() {
      this.$refs.voice.play();
      EventBus.$emit('voicePlayed', this.index);
      this.isPlaying = true;
      this.audioPlayed = true;
    },
    puaseVoice() {
      this.$refs.voice.pause();
      this.isPlaying = false;
    },
    formatSecond(sec) {
      let h = 0;
      let m = 0;
      let s = 0;
      if (sec > 3600) {
        h = Math.floor(sec / 3600);
        m = Math.floor(Math.floor(sec % 3600) / 60);
        s = Math.floor(m % 60);
        return `${h}:${m}:${s}`;
      }
      if (sec > 59) {
        m = Math.floor(sec / 60);
        s = Math.floor(sec % 60);
        return `${m}:${s}`;
      }
      m = '00';
      if (sec < 10) {
        s = `0${sec}`;
      }
      s = `${sec}`;
      return `${m}:${s}`;
    },
    openPhoto() {
      const m = {
        type: this.type,
        media: this.media,
        msg: this.message,
      };
      this.$emit('openPhoto', m);
    },
    customRightMenu(e) {
      e.preventDefault();
      if (this.selectMode) {
        return;
      }
      let xx = e.clientX;
      let yy = e.clientY;
      this.rightMenuPosition.overx = xx > (window.innerWidth - 192);
      this.rightMenuPosition.overy = yy > (window.innerHeight - 392);
      if (this.rightMenuPosition.overx) {
        xx -= 192;
      }
      if (this.rightMenuPosition.overy) {
        yy -= 250;
      }
      EventBus.$emit('rightClick', {
        i: this.index,
        left: xx,
        top: yy,
      });
      this.rightMenuPosition = {
        x: xx,
        y: yy,
      };
    },
    closeRightMenu() {
      EventBus.$emit('rightClickOff');
    },
    // img
    imgLoaded() {
    },
  },
  computed: {
    selecteds() {
      return this.$store.state.selectedMessages;
    },
    msgmar() {
      return `-${this.replyMargin}px`;
    },
  },
  watch: {
    selecteds() {
      if (this.selecteds.length === 0) {
        this.selected = false;
        this.selectMode = false;
      }
    },
    selectMode() {
      this.replyMargin = 0;
    },
    rightMenu() {
      this.closeRightMenuButton = true;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.replyTo !== undefined) {
        this.hasReply = true;
        // eslint-disable-next-line
        if (this.replyTo.type === 'voice' || this.replyTo.type === 'video' || this.replyTo.type === 'photo' || this.replyTo.type === 'file') {
          this.replyHasMedia = true;
        }
      }
      // ↓↓ on right click ↓↓
      EventBus.$on('rightClick', (event) => {
        if (event.i === this.index) {
          this.rightMenu = true;
        } else {
          this.rightMenu = false;
          this.closeRightMenuButton = true;
        }
      });
      EventBus.$on('rightClickOff', () => {
        this.rightMenu = false;
        this.closeRightMenuButton = false;
      });
      // on select mode ON
      EventBus.$on('selectModeOn', (event) => {
        this.selectMode = true;
        if (this.index === event.index) {
          this.selected = !this.selected;
          this.$store.commit('updateSelectedsArray', {
            id: this.id,
            add: this.selected,
          });
        }
      });
      // on select mode OFF
      EventBus.$on('selectModeOff', () => {
        this.selected = false;
        this.selectMode = false;
      });
      // if text
      // split message and detect # and @
      if (this.message.length !== 0) {
        const msg = this.message;
        const splitted = msg.split(' ');
        for (let i = 0; i < splitted.length; i += 1) {
          if (splitted[i].charAt(0) === '#') {
            splitted[i] = `<a href="${splitted[i]}" class="hashtag">${splitted[i]}</a>`;
          }
          if (splitted[i].charAt(0) === '@') {
            // eslint-disable-next-line
            splitted[i] = `<a href="https://app.rimik.ir/${splitted[i].substr(1, splitted[i].length)}" class="user">${splitted[i]}</a>`;
          }
          this.generatedMessage += `${splitted[i]} `;
        }
      }
      const [voice] = [this.$refs.voice];
      if (this.type === 'voice') {
        voice.addEventListener('ended', () => {
          voice.currentTime = 0;
          this.isPlaying = false;
        });
        voice.addEventListener('canplaythrough', () => {
          const d = voice.duration.toFixed(0);
          this.duration = this.formatSecond(d);
          this.time = `${this.duration}`;
        });
        // update time
        voice.ontimeupdate = () => {
          const c = voice.currentTime.toFixed(0);
          this.time = `${this.duration} / ${this.formatSecond(c)}`;
        };
        EventBus.$on('voicePlayed', (event) => {
          if (event !== this.index && this.isPlaying) {
            this.puaseVoice();
          }
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
  $primary: rgb(97, 24, 122);
  $secondary: rgb(43, 0, 58);
  $head: rgb(43, 0, 58);
  .selectBox {
    width: 0px;
    height: 0px;
    opacity: 0;
    position: relative;
    border-radius: 8px;
    border: solid 4px $primary;
    margin: 0;
  }
  .selectBox::after {
    position: absolute;
    top: 0;
    left: 10px;
    content: ' ';
    transform: rotate(0deg);
    opacity: 0;
    width: 0px;
    height: 0px;
    border: solid 4px $secondary;
    transition: all ease-in-out 0.2s;
    border-top: none;
    border-left: none;
  }
  .selectBox.selectedMsg::after {
    position: absolute;
    top: -8px;
    left: 6px;
    content: ' ';
    opacity: 1;
    transform: rotate(45deg);
    width: 8px;
    height: 16px;
    border: solid 4px $secondary;
    border-top: none;
    border-left: none;
  }
  .selectBox.show {
    width: 24px;
    height: 24px;
    opacity: 0.5;
    margin: 0 8px 0 -32px;
  }
  .selectBox.selectedMsg {
    opacity: 1;
    margin: 0 8px 0 -32px;
  }
  video {
    user-select: none;
  }
  .msgHolder {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    z-index: 100;
    .selectBigButton {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 999999;
    }
  }
  .msgHolder.otherHolder {
    flex-direction: row-reverse !important;
  }
  .msgHolder.rightMenued {
    z-index: 30000;
  }
  .rightMenu {
    position: fixed;
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 192px;
    z-index: 999999999999999999999999999999999999999;
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.25);
    li {
      text-decoration: none;
      list-style: none;
      list-style-type: none;
      padding: 16px;
      i {
        color: white;
        margin-left: 8px;
        font-size: 16px;
      }
      i.red {
        color: red;
      }
      label {
        color: white;
        font-weight: 300;
        font-size: 12px;
        text-align: right;
      }
    }
    li:hover {
      background-color: rgba($color: #000000, $alpha: 0.15);
    }
  }
  .rightMenu.overx {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -o-transform: translateX(-100%);
  }
  .rightMenu.overy {
    transform: translateY(-100%);
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    -moz-transform: translateY(-100%);
    -o-transform: translateY(-100%);
  }
  .msgBox {
    position: relative;
    padding: 4px 16px 4px;
    z-index: 10;
    .bilbilak {
      position: absolute;
      top: 4px;
      right: 8px;
      width: 16px;
      height: 32px;
      background-image: url('../assets/arrowyou.svg');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: top center;
    }
    .bilbilak.selectedB {
      right: 24px;
    }
    .avatar {
      width: 40px;
      height: 40px;
      min-width: 40px;
      border-radius: 50%;
      box-shadow: 0 4px 8px 0px rgba($color: #000000, $alpha: 0.25);
      background-color: orange;
    }
    .avatarHide{
      pointer-events: none;
      opacity: 0;
    }
    .msg {
      text-align: right;
      overflow: hidden;
      position: relative;
      margin: 0 8px;
      max-width: 264px;
      min-width: 114px;
      border-radius: 24px 0 8px 24px;
      flex-grow: 1;
      box-shadow: 0 4px 8px 0 rgba($color: #000000, $alpha: 0.05);
      background-color: $primary;
      border: solid 4px $primary;
      .photoHolder {
        width: 100%;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          min-height: 128px;
          cursor: pointer;
        }
        .playBtn {
          position: absolute;
          left: 50%;
          top: 50%;
          font-size: 32px;
          pointer-events: none;
          transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
          -o-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          padding: 4px;
          border-radius: 50%;
          color: rgba(0, 0, 0, 0.527);
          background-color: rgba(255, 255, 255, 0.473);
          box-shadow: 0 8px 8px 0 rgba($color: #000000, $alpha: 0.15);
        }
      }
      .voiceHolder {
        padding: 12px 12px 4px;
        .voiceVisualHolder {

        }
      }
      .replyBox {
        min-height: 48px;
        padding: 8px;
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.205);
        .holder {
          padding: 8px;
          border-radius: 0 16px 16px 0;
          border: solid 2px rgba(255, 255, 255, 0);
          border-right: solid 2px rgba(255, 255, 255, 0.267);
          .mediaPreview {
            width: 40px;
            height: 40px;
            min-width: 40px;
            background-color: rgba(255, 255, 255, 0.178);
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            margin-left: 8px;
            img {
              position: absolute;
              width: 100%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .replyContent {
            .to {
              font-size: 13px;
              font-weight: 300;
              color: white;
              text-align: right;
            }
            .msgPreview {
              font-size: 11px;
              font-weight: 100;
              overflow: hidden;
              text-align: right;
              max-height: 24px;
              color: white;
            }
          }
        }
      }
      .statusHolder {
        padding: 0 4px 0px 0;
      }
      .playButton {
        padding: 8px;
        font-size: 28px;
        cursor: pointer;
        color: $primary;
        position: relative;
        background-color: white;
        border-radius: 50%;
        margin: 0 0 8px 0;
        .played {
          position: absolute;
          top: 90%;
          left: 90%;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: white;
        }
      }
      .voiceTime {
        font-size: 12px;
        margin-top: -8px;
        line-height: 1;
        padding-bottom: 8px;
        color: rgba(255, 255, 255, 0.555);
      }
      .text {
        font-size: 13px;
        font-weight: 300;
        color: white;
        padding: 8px;
        a {
          font-size: inherit;
          display: inline-block !important;
          color: yellow !important;
          font-weight: 100;
        }
      }
      i {
        font-size: 16px;
        margin-left: 4px;
      }
      i.recived {
        color: rgb(172, 172, 255);
      }
      i.sent {
        color: rgba(175, 175, 255, 0.822);
      }
      i.pending {
        color: rgba(255, 255, 255, 0.336);
      }
      i.error {
        color: rgb(240, 76, 26);
      }
      .date {
        font-size: 10px;
        font-weight: 100;
        color: rgba(255, 255, 255, 0.349);
      }
    }
    .msg.round{
      border-radius: 24px 8px 8px 24px;
    }
  }
  .msgBox.selecteds {
    padding: 4px 32px 4px 16px;
  }
  .msgBox.other {
    direction: ltr;
    .bilbilak {
      position: absolute;
      top: 4px;
      left: 8px;
      width: 16px;
      height: 32px;
      background-image: url('../assets/arrowother.svg');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: top center;
    }
    .msg {
      border-radius: 0px 24px 24px 8px;
      border-color: $secondary;
      background-color: $secondary !important;
    }
    .msg.round {
      border-radius: 8px 24px 24px 8px;
    }
  }
  .selected {
    background-color: rgba(41, 0, 58, 0.212);
  }
</style>
